import { DataTableSetting } from './DataTableSetting';
import { DataTableField } from './DataTableField';
import { FieldEnum } from './FieldEnum';
import { TireStoringContract } from '@/models';

export class ContractDataTableSetting extends DataTableSetting {

  public static init(
      sortBy: string,
      sortDirection: string,
      fields: DataTableField[],
      items: any[] | Function,
      showCheckbox?: boolean,
      isRowClickSelected?: boolean): ContractDataTableSetting {
    const setting = new ContractDataTableSetting({
      sortBy,
      sortDirection,
      fields,
      items,
      isRowClickSelected,
    });
    if (showCheckbox) {
      setting.fields.unshift({
        key: 'checkbox',
        label: 'checkbox',
        type: FieldEnum.FIELD_CHECKBOX,
        sortable: false,
        thClass: 'checkbox-header',
      });
    }
    return setting;
  }

  public contracts: TireStoringContract[] = [];

  constructor(init?: Partial<DataTableSetting>) {
    super(init);
    Object.assign(this, init);
  }

}
